// extracted by mini-css-extract-plugin
export default {"root":"Zmq1mE"};